export default function CircularLoader({
  size = 20,
  thickness = 4,
  color = "black",
  trackColor = "#e5e7eb",
  label,
  inline = false
}) {
  const dimension = { width: size, height: size, borderWidth: thickness }

  const spinnerStyle = {
    ...dimension,
    borderStyle: "solid",
    borderRadius: "50%",
    borderColor: trackColor,
    borderTopColor: color,
    animation: "spin 1s linear infinite"
  }

  const containerStyle = inline
    ? { display: "inline-flex", alignItems: "center", gap: "8px" }
    : { display: "flex", alignItems: "center", justifyContent: "center", padding: "8px" }

  return (
    <div style={containerStyle} role="status" aria-live="polite" aria-busy="true">
      <div style={spinnerStyle}>
        <span
          style={{
            position: "absolute",
            width: 1,
            height: 1,
            padding: 0,
            overflow: "hidden",
            clip: "rect(0,0,0,0)",
            whiteSpace: "nowrap",
            border: 0
          }}
        >
          {label || "Loading"}
        </span>
      </div>

      {label && inline && (
        <span style={{ fontSize: "14px", color: "#4b5563" }} aria-hidden>
          {label}
        </span>
      )}

      <style>{`
@keyframes spin {
to { transform: rotate(360deg); }
}
`}</style>
    </div>
  )
}
